import * as yup from 'yup';

export const schema = yup.object({
  cod_cfop: yup.number().required(),
  des_cfop: yup.string().trim().required().max(500),
});
